

module.exports = __webpack_require__.stylable.create(
    "clearbutton3731144049",
    {"classes":{"root":"clearbutton3731144049__root"},"vars":{},"stVars":{"clearButtonColor":"rgba(0, 0, 0, 0.6)"},"keyframes":{}},
    "",
    1,
    /*! ../node_modules/@wix/search-box-v2/dist/src/components/ClearButton/ClearButton.st.css */ 1298,
    null
);
